__webpack_require__.p = "/malditectist-webapp-frontend/";